import useUserStore from "../../../store/useUserStore";
import { useNavigate } from "react-router-dom";

const Topbar = () => {

	const navigate = useNavigate();
	const { userInfo } = useUserStore();

	const handleLogoutClick = () => {
		localStorage.removeItem('access-token');
		localStorage.removeItem('refresh-token');
		localStorage.removeItem('access-exp');
		localStorage.removeItem('refresh-exp');
		navigate('/signin');
	}

	return (
		<header className="w-full min-h-[4.75rem] h-[clamp(4.75rem,10vw,4.25rem)] flex items-center justify-between bg-blue-dark px-3 sm:px-4 gap-3 shadow-sm">
			<div className="flex flex-1 items-center min-w-0">
				<p className="text-white font-semibold truncate text-[clamp(1.5rem,3.2vw,1.35rem)]">Raonzena PDA</p>
			</div>
			<div className="flex items-center gap-2 sm:gap-3 text-white">
				<p className="truncate max-w-[min(52vw,200px)] sm:max-w-[220px] text-[clamp(1.15rem,3.6vw,1.4rem)] font-medium leading-tight">
					{userInfo?.userNm}님
				</p>
				<button
					type="button"
					className="bg-red-500 hover:bg-red-600 active:bg-red-700 px-[0.85rem] py-[0.4rem] sm:px-4 sm:py-2 rounded-md text-[clamp(0.95rem,3vw,1.15rem)] font-semibold whitespace-nowrap shrink-0"
					onClick={handleLogoutClick}
				>
					로그아웃
				</button>
			</div>
		</header>
	);
}

export default Topbar;